import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/DiscoverLinkCard.css';

const DiscoverLinkCard = () => {
	const [isVisible, setIsVisible] = useState(true);
	const [compactMode, setCompactMode] = useState(false); // Track it with state
	// const compactMode = false; // Replace with your actual compact mode logic

	useEffect(() => {
		const closed = localStorage.getItem('discoverCardClosed');
		if (closed === 'true') {
			setIsVisible(false);
		}
		const compact = localStorage.getItem('discoverCardCompactMode');
		if (compact === 'true') {
			setCompactMode(true); // Set compact mode to true if the card was closed before
		}
	}, []);

	const handleClose = () => {
		setIsVisible(false);
		localStorage.setItem('discoverCardCompactMode', 'true'); //next time it will be in compact mode
	};

	const handleCloseCompactMode = () => {
		setIsVisible(false);
		localStorage.setItem('discoverCardClosed', 'true');
	};

	if (!isVisible) return null;

	const image = '/static/images/discover-placeholder.jpg';

	return (
		<div>
			{!compactMode && <h2>Discover More</h2>}
			<div className="discover-card">
				{!compactMode && <button className="close-btn" onClick={handleClose}>× close window</button>}
				{!compactMode && <img src={image} alt="discover.y02.nl promo image" />}
				<div className={compactMode ? "discover-info-compact" : "discover-info"}>
					<h3>Discover More on discover.y02.nl</h3>
					{!compactMode && <p style={{ maxWidth: '400px' }}>
						Explore other websites I've created or currently host! On <b>discover.y02.nl</b>, you'll find live projects and upcoming ideas. Click the button below to find out more (｡•̀ᴗ-)✧
					</p>}
					<div style={compactMode ? { display: 'flex', justifyContent: 'center', gap: '10px' } : undefined}>

						<button
							className="btn btn-primary"
							onClick={() => window.open('https://discover.y02.nl', '_blank')}
						>
							Visit discover.y02.nl
						</button>
						{compactMode && <button className="close-btn-compact" onClick={handleCloseCompactMode}>×</button>}
					</div>
				</div>
			</div>
		</div>
	);
};

export default DiscoverLinkCard;
